import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { acceptedFileUploadFileExtensions, fileUploadAcceptTypes, maxFileUploadSizeBytes } from 'src/app/shared/constants';
import { CustomValidators } from '../../form/dynamic-form/dynamic-form-field/validators/validators.model';
import {DynamicFormService} from "../../form/dynamic-form/dynamic-form.service";

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.scss'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class FileUploadComponent implements OnInit {
     private formService = inject(DynamicFormService);


     @Input() isFileSelected: boolean;
     @Input() selectedFileName: string;
     @Input() fieldID: string;
     @Input() fieldName: string;
     @Input() fControlName: string;
     @Input() required: boolean;
     @Input() invalid: boolean;
     @Input() acceptType = fileUploadAcceptTypes;
     @Input() acceptedFileExtensions = acceptedFileUploadFileExtensions;
     @Input() maxFileSizeBytes = maxFileUploadSizeBytes;
     @Input() fGroup: FormGroup;
     @Input() hasFileChanged = false;
     @Input() canDownload = true;
     @Input() viewOnly = false;
     @Input() canRemoveFile = false;
     @Output() fileChange = new EventEmitter();
     @Output() onDownload = new EventEmitter();
     selectedFile: File;
	@ViewChild('fileInput', { static: false }) fileInput: ElementRef<HTMLInputElement>;

     ngOnInit(): void {


     	if (!this.viewOnly) {
     		const validators = [];

     		if (this.required && !this.isFileSelected) {
     			validators.push(CustomValidators.fileRequired(null));
     			this.fGroup?.controls[this.fControlName].setValidators(validators);

     			this.fGroup?.controls[this.fControlName].updateValueAndValidity();
     		}
     	}
     }

     fileChanged(event: any): void {
     	this.hasFileChanged = true;
     	this.isFileSelected = true;

     	if (!this.viewOnly) {
     		let validators = [];
     		if (event.target.files && event.target.files.length > 0) {
     			this.selectedFile = <File>event.target.files[0];

     			validators = [
     				CustomValidators.filesize(this.selectedFile, this.maxFileSizeBytes),
     				CustomValidators.fileextension(this.selectedFile, this.acceptedFileExtensions)
     			];
     		}
     		else {
     			this.selectedFile = undefined;
     		}

     		if (this.required) {
     			validators.push(CustomValidators.fileRequired(event));
     		}

     		this.fGroup?.controls[this.fControlName]?.setValidators(validators);

     		this.fGroup?.controls[this.fControlName]?.updateValueAndValidity();


			 setTimeout(() => {
				 // Reset the file input value to allow re-uploading the same file
				 this.fileInput.nativeElement.value = '';
			 }, 100);
     	}

     	this.fileChange.emit(event);
     }

     removeFile(): void {
     	this.hasFileChanged = true;
     	this.isFileSelected = false;
     	this.selectedFile = undefined;
     	this.fileChange.emit();
     }
}
